import getLabelSize from 'helpers/markups/getLabelSize'

// label has position
export default function typeSpecificInfo({ overlay, type, zoom }) {
  switch (type) {
    case 'circle':
      return {
        location: { lat: overlay.center.lat(), lng: overlay.center.lng() },
        radius: overlay.getRadius()
      }
    case 'polygon':
      return {
        location: overlay.getPaths().getArray()[0].getArray().map(l => ({ lat: l.lat(), lng: l.lng() }))
      }
    case 'polyline':
      return {
        location: overlay.getPath().getArray().map(l => ({ lat: l.lat(), lng: l.lng() }))
      }
    case 'wall':
      return {
        location: overlay.getPath().getArray().map(l => ({ lat: l.lat(), lng: l.lng() }))
      }
    case 'rectangle':
      return {
        location: overlay.getBounds().toJSON()
      }
    case 'label':
      return {
        location: { lat: overlay.location.lat(), lng: overlay.location.lng() },
        text: overlay.text,
        dimensions: overlay.dimensions,
        size: getLabelSize(zoom)
      }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/markups/typeSpecificInfo.js